import script from "./BroadcastServiceInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastServiceInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./BroadcastServiceInfoCard.vue?vue&type=style&index=0&id=73f778a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73f778a7"]])

export default __exports__